import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { PreviewTooltip } from "@/components/tooltip/PreviewTooltip";
import { ItemPreviewTooltipFragment } from "./ItemPreviewTooltip.fragment";
import { ItemPreviewTooltipContent } from "./ItemPreviewTooltipContent";
export function ItemPreviewTooltip(t0) {
  const $ = _c(10);
  let itemKey;
  let rest;
  if ($[0] !== t0) {
    ({
      item: itemKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = itemKey;
    $[2] = rest;
  } else {
    itemKey = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== itemKey) {
    t1 = readFragment(ItemPreviewTooltipFragment, itemKey);
    $[3] = itemKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const item = t1;
  let t2;
  if ($[5] !== item) {
    t2 = <ItemPreviewTooltipContent item={item} />;
    $[5] = item;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== rest || $[8] !== t2) {
    t3 = <PreviewTooltip content={t2} {...rest} />;
    $[7] = rest;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}